import { render, staticRenderFns } from "./StudentAttendanceReport.vue?vue&type=template&id=0a253d88&lang=true&"
import script from "./StudentAttendanceReport.vue?vue&type=script&lang=js&"
export * from "./StudentAttendanceReport.vue?vue&type=script&lang=js&"
import style0 from "./StudentAttendanceReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports